import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="flex justify-center bg-gray-100 py-8 px-4 font-['Poppins']">
      <div className="w-full max-w-4xl">
        <h1 className="text-center text-xl font-medium text-[#53686A] mb-6">Privacy Policy</h1>
        
        <div className="bg-white p-6 md:p-8 border border-black">
          <div className="mb-6">
            <p className="text-sm md:text-base text-gray-800 leading-relaxed">
              Hellocer is committed to providing a secure and transparent platform for connecting job seekers with potential 
              employers, we understand the importance of protecting your privacy and personal information. This note serves 
              to outline our privacy policy, detailing how we collect, use, and protect your data.
            </p>
          </div>

          <div className="mb-6">
            <h2 className="font-medium text-sm md:text-base">1. Information we Need</h2>
            <div className="ml-4 md:ml-6 space-y-3 mt-2">
              <div>
                <p className="text-sm md:text-base text-gray-800 leading-relaxed">
                  <span className="mr-1">1.1.</span> When you create an account on our website, apply for a job, or post a job listing, we may collect personal 
                  information such as your name, email address, contact details, employment history, education background, 
                  and other relevant details.
                </p>
              </div>
              <div>
                <p className="text-sm md:text-base text-gray-800 leading-relaxed">
                  <span className="mr-1">1.2.</span> We may also collect information about your usage of our website, including but not limited to your IP 
                  address, browser type, and pages visited. This information helps us improve our services and user experience.
                </p>
              </div>
            </div>
          </div>

          <div className="mb-6">
            <h2 className="font-medium text-sm md:text-base">2. Usefulness of your Information</h2>
            <div className="ml-4 md:ml-6 space-y-3 mt-2">
              <div>
                <p className="text-sm md:text-base text-gray-800 leading-relaxed">
                  <span className="mr-1">2.1.</span> We use the information we collect to provide and improve our services, including matching job seekers 
                  with suitable job opportunities, facilitating communication between employers and job seekers, and 
                  optimizing our platform's functionality.
                </p>
              </div>
              <div>
                <p className="text-sm md:text-base text-gray-800 leading-relaxed">
                  <span className="mr-1">2.2.</span> We may use your contact information to send you notifications, updates, and other communications 
                  related to your account or the services we provide. You can opt out of promotional communications at 
                  any time.
                </p>
              </div>
              <div>
                <p className="text-sm md:text-base text-gray-800 leading-relaxed">
                  <span className="mr-1">2.3.</span> We analyze user data to understand trends, usage patterns, and preferences, which helps us enhance 
                  our services and tailor our offerings to better meet the needs of our users.
                </p>
              </div>
            </div>
          </div>

          <div className="mb-6">
            <h2 className="font-medium text-sm md:text-base">3. Data Sharing</h2>
            <div className="ml-4 md:ml-6 space-y-3 mt-2">
              <div>
                <p className="text-sm md:text-base text-gray-800 leading-relaxed">
                  <span className="mr-1">3.1.</span> When you apply for a job, your application materials, including your resume and cover letter, may be 
                  shared with the employer who posted the job listing.
                </p>
              </div>
              <div>
                <p className="text-sm md:text-base text-gray-800 leading-relaxed">
                  <span className="mr-1">3.2.</span> We may engage third-party service providers to assist us in providing and improving our services, such 
                  as hosting providers, analytics platforms, and communication tools. These service providers are contractually 
                  obligated to protect your information and only use it for the purposes specified by us.
                </p>
              </div>
              <div>
                <p className="text-sm md:text-base text-gray-800 leading-relaxed">
                  <span className="mr-1">3.3.</span> We may disclose your information if required by law or in response to valid legal requests, such as 
                  or court orders.
                </p>
              </div>
            </div>
          </div>

          <div className="mb-6">
            <h2 className="font-medium text-sm md:text-base">4. Data Security</h2>
            <div className="ml-4 md:ml-6 space-y-3 mt-2">
              <div>
                <p className="text-sm md:text-base text-gray-800 leading-relaxed">
                  <span className="mr-1">4.1.</span> Hellocer employ standard security measures to protect your personal information from unauthorized 
                  access, misuse, and alteration. However, no method of transmission over the internet or electronic storage is 
                  totally secure, and we cannot guarantee absolute security.
                </p>
              </div>
            </div>
          </div>

          <div className="mb-6">
            <h2 className="font-medium text-sm md:text-base">5. Your Right and Choices</h2>
            <div className="ml-4 md:ml-6 space-y-3 mt-2">
              <div>
                <p className="text-sm md:text-base text-gray-800 leading-relaxed">
                  <span className="mr-1">5.1.</span> You have the right to access and correct any personal information we hold about you. You can update 
                  your account information or contact us to request changes.
                </p>
              </div>
              <div>
                <p className="text-sm md:text-base text-gray-800 leading-relaxed">
                  <span className="mr-1">5.2.</span> You can request the deletion of your account and associated data at any time. However, please note 
                  that certain information may be retained for legal or administrative purposes.
                </p>
              </div>
            </div>
          </div>

          <div className="mb-6">
            <h2 className="font-medium text-sm md:text-base">6. Underage Privacy</h2>
            <div className="ml-4 md:ml-6 space-y-3 mt-2">
              <div>
                <p className="text-sm md:text-base text-gray-800 leading-relaxed">
                  <span className="mr-1">6.1.</span> Hellocer services are not intended for individuals under the age of 18. We do not knowingly collect personal 
                  information from underage. If we become aware that we have inadvertently collected personal information 
                  from a underage, we will take steps to delete it immediately.
                </p>
              </div>
            </div>
          </div>

          <div className="mb-6">
            <h2 className="font-medium text-sm md:text-base">7. Updates on Privacy Policy</h2>
            <div className="ml-4 md:ml-6 space-y-3 mt-2">
              <div>
                <p className="text-sm md:text-base text-gray-800 leading-relaxed">
                  <span className="mr-1">7.1.</span> We reserve the right to update our privacy policy from time to time to reflect changes in our practices or 
                  applicable laws. We will notify you of any material changes to our privacy policy by posting the updated 
                  version on our website or contacting you directly.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;